var map;
var initMap = function initMap() {
  var ranInit = false;
  console.log('Map initializing');
  const map = new google.maps.Map(document.getElementById("registration-map"), {
    center: { lat: 52.1326, lng: 5.2913 },
    zoom: 8,
  });

  map.addListener('idle', function () {

    // Trigger the load applications function when  the map is done loading
    if(!ranInit ) {
      // Only run the render function once
      window.loadProjectApplications(map);
      ranInit = true;

    }
  });
}
